module.exports = __webpack_public_path__ + "static/media/12pic.8eb4b401.jpg";